import classNames from 'classnames'
import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import rechargeMobileIcon from '../../assets/rechargeMobileIcon.svg'
import { Spinner } from 'utils/loading'
import paimentFactureContext from 'contexts/paimentFactureContext'
import imageBgRecharge from '../../assets/imageBgRecharge.svg'
import btnDeleted from '../../assets/btnDeleted.svg'
import btnSteg from '../../assets/logoModalSteg.svg'
import btnSoned from '../../assets/logoModalSoned.svg'
import Topnet from '../../assets/logoModalTopnet.svg'
import BGModal from  '../../assets/modalBG.svg'



interface Props {
  isOpen: boolean
  closeModal: () => void
  successPayment: string
  isInvoices?: string
  // isAssurance?: boolean
  loadingUrlConfirmed?: boolean
  iconOperateur?:string
  // isSuccess?:boolean
}

const SuccessPaymentModal: React.FC<Props> = ({
  isOpen,
  closeModal,
  successPayment,
  isInvoices,
  // isSuccess,
  // isAssurance,
  loadingUrlConfirmed= true,
  iconOperateur
}) => {

  const { paimentFacture, setPaimentFacture } = useContext(paimentFactureContext)

  if (!isOpen) return null
  const navigate = useNavigate()
  const activeText = 
  isInvoices==='Recharge' ? 4 
  : isInvoices==='facture'? 6 
  : isInvoices ==='assurance' && 4

  return (
    // <div>
   
          <div
          className={classNames(
            'fixed flex flex-col justify-center place-items-center inset-0  z-50 bg-[#4945c12f] backdrop-blur-sm',
          )}
        >
          <img
         
            className={` -mb-[25px]  ${paimentFacture?.logoOperateur && ' rounded-full shadow-xl bg-[#EEEEEE] border-white border-[5px]'}`}
            src={
              iconOperateur
              ?iconOperateur
              :paimentFacture?.logoOperateur
              ?paimentFacture?.logoOperateur

              : btnDeleted
            }
            width={88}
            height={88}
            alt="Person Image"
          />
          <img src={BGModal} width={327} height={78} alt=''/>
         
            <div className=" w-[327px] px-[24px] pb-[24px] rounded-b-[16px] flex flex-col justify-center items-center  bg-[#FFF]">
              <div className="text-[#1D3A70] text-[25px] sm:text-[20px] md:text[20px] font-bold pb-1 text-center">
                {successPayment === 'succeeded' ? (
                  <div className="flex flex-col items-center justify-center">
                    {isInvoices==='facture' ? (
                      <div>
                        <div className=" flex flex-col items-center justify-center gap-4">
                          <h2 className='text-[#1D3A70]'>Paiement Réussie</h2>
                          <div className='flex items-center gap-20 justify-between  w-full  border-b text-[16px] pb-2'>
                            <div className='text-[#6B7280] font-normal'>Réference</div>
                            <div className='font-medium' >+216 {paimentFacture?.objectReference}</div>
                          </div>
                          <div className='flex items-center justify-between  w-full  border-b text-[16px] pb-2'>
                            <div className='text-[#6B7280] font-normal'>Montant en Euro</div>
                            <div className=' font-medium'> {Number(paimentFacture?.amountToPay).toLocaleString('fr-FR', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 3,
                          })} €</div>
                          </div>
                          <div className='flex items-center justify-between  w-full  border-b text-[16px] pb-2'>
                            <div className='text-[#6B7280] font-normal'>Montant en Dinars</div>
                            <div className=' font-medium'> {paimentFacture?.amountTND} TND</div>
                          </div>
                          
                          

                        </div>
                      </div>
                    ) : isInvoices==='assurance' ? (
                      <div className="flex flex-col items-center justify-center">
                        <div>
                          <div className="mt-5">Assurance envoyée avec succès.</div>
                        </div>
                      </div>
                    ) :
                    isInvoices==='Recharge'&&
                     (
                      <div className=' flex flex-col items-center justify-center'>
                        <img src={rechargeMobileIcon} className="w-[150px] h-[150px] " />
                        <div className="mt-5">Recharge mobile envoyée avec succès.</div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="flex flex-col items-center justify-center">
                    {/* {isInvoices ? (
                      <div className="mt-5">Le paiement a échoué.<br/> Veuillez réessayer.</div>
                    ) : !isAssurance ? (
                      <div className="flex flex-col items-center justify-center">
                        <div>
                          <div className="mt-5">Le paiement a échoué.<br/> Veuillez réessayer.</div>
                        </div>
                      </div>
                    ) : ( */}
                      <div className=' flex flex-col items-center justify-center'>
                        <img src={rechargeMobileIcon} className="w-[150px] h-[150px] " />
                        <div className="mt-5">Le paiement a échoué.<br/> Veuillez réessayer.</div>
                      </div>
                    {/* )} */}
                  </div>
                )}
              </div>
              <button
                disabled={!loadingUrlConfirmed}
                onClick={() => {
                  closeModal()
                  navigate(`/history?activeText=${activeText }`)
                  setPaimentFacture({})
                }}
                className={`rounded-xl h-[50px] mt-8 text-white text-[15px] w-[250px] font-medium bg-[#5754E5]
                ${successPayment === 'succeeded' ? 'bg-[#5754E5]' : 'bg-red-500'}
                `}
              >
                {!loadingUrlConfirmed ? (
                  <Spinner name="line-scale-pulse-out-rapid" color="#1466ff" fadeIn="none" />
                ) : (
                  'Ok'
                )}
              </button>
            </div>
          </div>
        // </div>
     
  )
}

export default SuccessPaymentModal
